<template>
    <tr>
        <td v-if="(hasFinancialControlRights || hasFinancialControlUnlockRights) && !isLockedForEdit" class="px-1" style="max-width: 50px; vertical-align: middle;">
            <div v-if="hasFinancialControlUnlockRights && item.id && item.disalbedForEdit === true"
                class="btn-group" role="group"
            >
                <h6 class="badge badge-primary mt-2 pt-1">{{ $t('yes') }}</h6>
                <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click.stop="$emit('unlockFinancialControl', item.id)"
                >
                    <i class="fas fa-lock-open"></i>
                </button>
            </div>
            <toggle
                v-else
                v-model="item.financialControl"
                :disabled="!hasFinancialControlRights && (hasFinancialControl || isLockedForEdit)"
            />

        </td>
        <td>{{ item.personName }}</td>
        <td>
            <div v-if="!isLockedForEdit">
                <input type="text" class="form-control" style="font-size: 0.9rem;"
                    v-model="item.businessTripOrderNumber"
                    :readonly="item.financialControl">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.businessTripOrderNumber}}
            </div>
        </td>
        <td class="dateMinWidth" style="max-width: 140px;">
            <date-picker
                v-model="item.businessTripDateFrom"
                :readonly="item.financialControl || isLockedForEdit"
                :show-time="false"
                font-size="0.9rem"
            />
        </td>
        <td class="dateMinWidth">
            <date-picker
                v-model="item.businessTripDateTo"
                :readonly="item.financialControl || isLockedForEdit"
                :show-time="false"
                font-size="0.9rem"
            />
        </td>
        <td class="numberColumnWidth">
            <input type="number"
                class="form-control"
                style="font-size: 0.9rem"
                v-model.number="item.days"
                min="0"
                step="1"
                :readonly="item.financialControl || isLockedForEdit">
        </td>
        <td class="numberColumnWidth">
            <div v-if="!isLockedForEdit">
                <input type="number" class="form-control" style="font-size: 0.9rem;"
                    v-model="item.moneyDayRate"
                    :readonly="item.financialControl || isLockedForEdit">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.moneyDayRate}}
            </div>
        </td>
        <td class="numberColumnWidth" style="font-size: 0.9rem;">
            {{ daySum }}
        </td>
        <td class="dateMinWidth">
            <date-picker
                v-model="item.nightsFrom"
                :readonly="item.financialControl || isLockedForEdit"
                :show-time="false"
                font-size="0.9rem"
            />
        </td>
        <td class="dateMinWidth">
            <date-picker
                v-model="item.nightsTo"
                :readonly="item.financialControl || isLockedForEdit"
                :show-time="false"
                font-size="0.9rem"
            />
        </td>
        <td class="numberColumnWidth">
            <input type="number"
                class="form-control"
                style="font-size: 0.9rem"
                v-model.number="item.nightsCount"
                min="0"
                step="1"
                :readonly="item.financialControl || isLockedForEdit">
        </td>
        <td class="numberColumnWidth" style="font-size: 0.9rem;">
            <div v-if="!isLockedForEdit">
                <input type="number" class="form-control"
                    style="font-size: 0.9rem;"
                    v-model="item.singlePrice"
                    :readonly="item.financialControl">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.singlePrice}}
            </div>
        </td>
        <td class="numberColumnWidth" style="font-size: 0.9rem;">
            {{ apartmentSum }}
        </td>
        <td class="numberColumnWidth">
            <div v-if="!isLockedForEdit">
                <input type="number" class="form-control"
                    style="font-size: 0.9rem;"
                    v-model="item.roadGoingMoney"
                    :readonly="item.financialControl">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.roadGoingMoney}}
            </div>
        </td>
        <td class="dateMinWidth">
            <date-picker
                v-model="item.roadGoingDate"
                :readonly="item.financialControl || isLockedForEdit"
                :show-time="false"
                font-size="0.9rem"
            />
        </td>
        <td class="numberColumnWidth">
            <div v-if="!isLockedForEdit">
                <input type="number" class="form-control"
                    style="font-size: 0.9rem;"
                    v-model="item.roadReturningMoney"
                    :readonly="item.financialControl">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.roadReturningMoney}}
            </div>
        </td>
        <td class="dateMinWidth">
            <date-picker
                v-model="item.roadReturningDate"
                :readonly="item.financialControl || isLockedForEdit"
                :show-time="false"
                font-size="0.9rem"
            />
        </td>
        <td style="font-size: 0.9rem;">{{ roadSum }}</td>
        <td class="numberColumnWidth" style="font-size: 0.9rem;">
            {{ allMoneySum }}
        </td>
        <td class="numberColumnWidth">
            <div v-if="!isLockedForEdit">
                <input type="number" class="form-control" style="font-size: 0.9rem;"
                    v-model="item.paidExpenses">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.paidExpenses}}
            </div>
        </td>
        <td class="dateMinWidth">
            <date-picker
                v-model="item.paymentDate"
                :readonly="isLockedForEdit"
                :show-time="false"
                font-size="0.9rem"
            />
        </td>
        <td>
            <div v-if="!isLockedForEdit">
                <input type="text" class="form-control" style="font-size: 0.9rem;"
                    v-model="item.excerpt">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.excerpt}}
            </div>
        </td>
        <td>
            <div v-if="!isLockedForEdit">
                <input type="text" class="form-control" style="font-size: 0.9rem;"
                    v-model="item.accountingProgram">
            </div>
            <div v-else style="font-size: 0.9rem;">
                {{item.accountingProgram}}
            </div>
        </td>
        <td class="numberColumnWidth" style="font-size: 0.9rem;">{{ difference }}</td>
        <td class="textAreaMinWidth">
            <textarea type="text" class="form-control"
                :disabled="isLockedForEdit"
                v-model="item.notes"
                style="font-size: 0.9rem;"
            />
        </td>
        <td style="max-width: 200px; vertical-align: middle;">
            <div v-if="!item.financialControl && !isLockedForEdit" class="text-center">
                <i class="pointer fas fa-upload text-primary"
                    data-toggle="tooltip"
                    :title="$t('buttons.add.tooltipText')"
                   @click="fileUploadClicked(index)"></i>
            </div>
            <div v-for="file in item.files" :key="file.id">
                <div v-if="loading" class="loader"></div>
                <div v-else>
                    <button v-if="file.id" class="btn btn-link btn-primary text-left m-0 p-0" style="font-size: 0.8em; display: inline-flex;" @click.stop="download(file)">
                        {{ file.fileName }}
                        <i v-if="!item.financialControl && !isLockedForEdit"
                            class="fas fa-minus-circle text-danger float-right pointer pl-1 pt-1"
                            data-toggle="tooltip"
                            :title="$t('buttons.delete.tooltipText')"
                            @click="removeFile(file)">
                        </i>
                    </button>
                    <a v-else style="font-size: 0.8rem;">{{ file.fileName }}</a>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
    import { BudgetReportItemModel } from '@/models/models';
    import DatePicker from '../datepicker/DateTimePicker';
    import Toggle from '../toggle/Toggle';
    import helpers from '../../helpers/helpers';

    export default {
        props: {
            item: {
                type: BudgetReportItemModel
            },
            hasFinancialControlRights: {
                type: Boolean,
            },
            hasFinancialControlUnlockRights: {
                type: Boolean,
            },
            index: {
                type: Number
            },
            eventDateFrom: {
                type: [Date, String]
            },
            eventDateTo: {
                type: [Date, String]
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
        },
        components: {
            DatePicker,
            Toggle
        },
        data() {
            return {
                hasFinancialControl: false,
                baseUrl: this.$store.getters.baseUrl,
                loading: false,
            }
        },
        methods: {
            fileUploadClicked(index) {
                this.$emit('onItemUploadFilesClicked', index);
            },
            initDates() {
                if (!this.item.id) {
                    let dateFrom = '';
                    if (this.eventDateFrom) {
                        dateFrom = new Date(this.eventDateFrom);
                        dateFrom.setDate(dateFrom.getDate() - 1);
                    }

                    let dateTo = '';
                    if (this.eventDateFrom) {
                        dateTo = new Date(this.eventDateTo);
                        dateTo.setDate(dateTo.getDate() - 1);
                    }

                    this.item.businessTripDateFrom = dateFrom;
                    this.item.businessTripDateTo = dateTo;
                    this.item.nightsFrom = dateFrom;
                    this.item.nightsTo = dateTo;
                    this.item.roadGoingDate = dateFrom;
                    this.item.roadReturningDate = dateTo;
                }
            },
            removeFile(file) {
                this.clickedItem();
                file.budgetReportItemId = this.item.id;
                this.$emit('fileToBeRemoved', file);
            },
            clickedItem() {
                this.$emit('clickedItemIndex', this.index);
            },
            download(file) {
                const downloadUri = this.$store.getters.baseUrl + `/api/file/download/?id=${file.id}&type=${file.docTypeCode}&hash=${file.hash}`;
                this.loading = true;

                this.$http.get(downloadUri, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data]);
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.fileName); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        })
                    })
                    .finally(() => { this.loading = false; });
            },
            calcDaysCount() {
                if (this.item.businessTripDateFrom && this.item.businessTripDateTo) {
                    const dateFrom = new Date(this.item.businessTripDateFrom);
                    const dateTo = new Date(this.item.businessTripDateTo);

                    if (dateFrom && dateTo) {
                        let days = Math.round((dateTo - dateFrom) / this.oneDay) + 1;
                        this.item.days = days;
                    }
                }
            },
            calcNightsCount() {
                if (this.item.nightsFrom && this.item.nightsTo) {
                    const dateFrom = new Date(this.item.nightsFrom);
                    const dateTo = new Date(this.item.nightsTo);

                    if (dateFrom && dateTo) {
                        const count = Math.round((dateTo - dateFrom) / this.oneDay)
                        this.item.nightsCount = count;
                    }
                }
            },
        },
        watch: {
            'item.businessTripDateFrom': function () {
                this.calcDaysCount();
            },
            'item.businessTripDateTo': function (newVal, oldVal) {
                this.calcDaysCount();

                const dateFrom = new Date(this.item.businessTripDateFrom);
                if (dateFrom) {
                    if (dateFrom > new Date(newVal)) {
                        this.$vs.notify({
                            title: this.$t('notifications.warning'),
                            text: this.$t('notifications.dateFromBiggerThanDateTo'),
                            position: 'bottom-right',
                            color: 'warning',
                            duration: 5000
                        });
                    }
                }
            },
            'item.nightsFrom': function () {
                this.calcNightsCount();
            },
            'item.nightsTo': function (newVal, oldVal) {
                this.calcNightsCount();

                const dateFrom = new Date(this.item.nightsFrom);
                if (dateFrom) {
                    if (dateFrom > new Date(newVal)) {
                        this.$vs.notify({
                            title: this.$t('notifications.warning'),
                            text: this.$t('notifications.dateFromBiggerThanDateTo'),
                            position: 'bottom-right',
                            color: 'warning',
                            duration: 5000
                        });
                    }
                }
            },
        },
        computed: {
            daySum: function () {
                const sum = this.item.days * this.item.moneyDayRate;
                if (!isNaN(sum)) {
                    this.item.daySum = sum;
                    this.$emit('daySumChanged');
                    return sum;
                }

                this.$emit('daySumChanged');
                return 0;
            },
            oneDay: function () {
                return 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            },
            roadSum: function () {
                let sum = 0;
                const goingMoney = parseFloat(this.item.roadGoingMoney);
                if (!isNaN(goingMoney)) {
                    sum += goingMoney;
                }

                const returningMoney = parseFloat(this.item.roadReturningMoney);
                if (!isNaN(returningMoney)) {
                    sum += returningMoney;
                }

                this.item.roadSum = sum;
                this.$emit('roadSumChanged');
                return helpers.roundToSecondDigit(sum);
            },
            apartmentSum: function () {
                let sum = 0;
                const singlePrice = parseFloat(this.item.singlePrice); // TODO: Refactor to singlePriceForNight if it is really for nights...
                if (!isNaN(singlePrice)) {
                    sum += (singlePrice * this.item.nightsCount);
                }

                this.item.appartmentSum = sum;
                this.$emit('apartmentSumChanged');
                return helpers.roundToSecondDigit(sum);
            },
            allMoneySum: function () {
                const sum = this.item.daySum + this.roadSum + this.apartmentSum;
                this.item.allMoneySum = sum;
                this.$emit('totalSumChanged');
                return helpers.roundToSecondDigit(sum);
            },
            difference: function () {
                if (this.item.accountingProgram) {
                    if (this.allMoneySum !== this.item.accountingProgram) {
                        return helpers.roundToSecondDigit(this.allMoneySum - this.item.accountingProgram);
                    }
                }

                return '';
            }
        },
        mounted() {
            this.item.uid = this._uid;
            this.initDates();
            this.hasFinancialControl = this.item.financialControl;
            if (this.hasFinancialControl) {
                this.item.disalbedForEdit = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep {
        .dateMinWidth {
            min-width: 125px;
        }

        .numberMinWidth {
            min-width: 90px;
        }

        .numberColumnWidth {
            min-width: 90px;
            max-width: 110px;
        }

        .textAreaMinWidth {
            min-width: 200px;
        }
        td {
            font-size: 0.8rem;
        }
    }
</style>
